import BlockLeftImage from "../components/BlockLeftImage";
import FixedHeader from "../components/FixedHeader";
import BlockImageCabecera from "../components/BlockImageCabecera";
import DataFetcherTemplate from "../hooks/fetchTemplate";
import BlockRightImage from "../components/BlockRightImage";
import Card from "../components/Card";

function Gem() {
  const DataDisplay = ({ data }) => (
    <>
      <>
        {data.map((item, index) => (
          <>
            <BlockImageCabecera
            src={item.field_portada}
              title={
                <>
                  {" "}
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque13,
                    }}
                  />
                </>
              }
            ></BlockImageCabecera>
         
            <div className="layout8 padding">
              <div
                dangerouslySetInnerHTML={{
                  __html: item.field_texto_portada,
                }}
              />
            </div>
            <div className="lightbluebg">
              <BlockLeftImage
                src={item.field_imagen1}
                content={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque1,
                    }}
                  />
                }
              ></BlockLeftImage>
            </div>
            <div className="padding bluebg">
              <div
                className="layout8"
                dangerouslySetInnerHTML={{
                  __html: item.field_bloque2,
                }}
              />
            </div>

            <BlockRightImage
              src={item.field_imagen3}
              content={
                <>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque3,
                    }}
                  />
                </>
              }
            ></BlockRightImage>
            <div className=" padding lightbluebg">
              <div
                className="layout8"
                dangerouslySetInnerHTML={{
                  __html: item.field_bloque11,
                }}
              />
            </div>

            <div className="padding">
              <div
                className=" icon400"
                dangerouslySetInnerHTML={{
                  __html: item.bloque12,
                }}
              />
            </div>

            <div className=" graybg padding">
              <div
                className="layout8"
                dangerouslySetInnerHTML={{
                  __html: item.field_bloque4,
                }}
              />

              <div className="layout8 flex-center card250">
                <Card
                  src={item.field_imagen5}
                  alt="utpl"
                  content={
                    <>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque5,
                        }}
                      />
                    </>
                  }
                ></Card>

                <Card
                  src={item.field_imagen6}
                  alt="utpl"
                  content={
                    <>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque6,
                        }}
                      />
                    </>
                  }
                ></Card>
                <Card
                  src={item.field_imagen7}
                  alt="utpl"
                  content={
                    <>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque7,
                        }}
                      />
                    </>
                  }
                ></Card>
                <Card
                  src={item.field_imagen8}
                  alt="utpl"
                  content={
                    <>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque8,
                        }}
                      />
                    </>
                  }
                ></Card>
                <Card
                  src={item.field_imagen9}
                  alt="utpl"
                  content={
                    <>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque9,
                        }}
                      />
                    </>
                  }
                ></Card>
                <Card
                  src={item.field_imagen10}
                  alt="utpl"
                  content={
                    <>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque10,
                        }}
                      />
                    </>
                  }
                ></Card>
              </div>
            </div>
          </>
        ))}
      </>
    </>
  );
  return (
    <>
      {" "}
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/services/servicio-gem.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>
    </>
  );
}

export default Gem;
